<template>
  <div class="works-box">
    <div v-for="(item, i) in workArr" :key="i">
      <template>
        <div
          class="map-work-box"
          v-if="group == 50"
          @click="toDetail(item.wid)"
        >
          <div class="cover-box">
            <img :src="item.cover" />
          </div>
          <div class="map-content">
            <p class="work-name">{{ item.name }}</p>
            <div class="uin">
              <span class="nickname">{{ item.uinfo.nickname }}</span>
              <span>{{ item.uinfo.uin }}</span>
            </div>
            <div class="school">
              <img src="../assets/images/icon_location.png" />
              <span>{{ item.uinfo.schoolName }}</span>
            </div>
            <div class="down-like">
              <div class="down">
                <img src="../assets/images/icon_download.png" />
                <span>{{ item.downloads }}</span>
              </div>
              <div class="like">
                <img src="../assets/images/icon_like.png" />
                <span>{{ item.thumbUp }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="good-works-box" v-else @click="toDetail(item.wid)">
          <div class="top">
            <img :src="item.cover" />
            <div class="work-txt-box">
              <p>类型：模型</p>
              <p v-if="item.tags">标签：{{ item.tags | getTags }}</p>
            </div>
          </div>
          <div class="bottom">
            <p class="work-name">{{ item.name }}</p>
            <div class="uin child">
              <p class="nickname">{{ item.uinfo.nickname }}</p>
              <p>{{ item.uinfo.uin }}</p>
            </div>
            <div class="school child">
              <img src="../assets/images/icon_location.png" />
              <span>{{ item.uinfo.schoolName }}</span>
            </div>
            <div class="down-like child">
              <div class="down">
                <img src="../assets/images/icon_download.png" />
                <span>{{ item.downloads }}</span>
              </div>
              <div class="like">
                <img src="../assets/images/icon_like.png" />
                <span>{{ item.thumbUp }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { divisionIdM, divisionIdG } from '../common/argumentId';
export default {
  name: 'workBox',
  props: {
    group: {
      type: String
    },
    workArr: {
      type: Array
    }
  },
  methods: {
    toDetail(wid) {
      let divisionId = this.group == 60 ? divisionIdG : divisionIdM;
      this.$router.push(`details/${divisionId}/${wid}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.works-box {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .map-work-box {
    width: 340px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .cover-box {
      width: 340px;
      height: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
  }
  .map-content {
    height: 200px;
    padding: 20px 20px 10px 20px;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    img {
      margin-right: 10px;
    }
  }
  .good-works-box {
    width: 340px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .top {
      display: flex;
      justify-content: space-between;
      img {
        width: 140px;
        height: 140px;
        background: url('../assets/images/bg_resbg.png') no-repeat top
          center/140px 140px;
        background-color: #f3f3f3;
      }
      .work-txt-box {
        padding: 10px 0 10px 10px;
        width: 200px;
        background-color: #f3f3f3;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
    .bottom {
      padding: 20px 20px 10px 20px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      background: #f7f7f7;
      img {
        margin-right: 10px;
      }
    }
  }

  .uin {
    display: flex;
    justify-content: space-between;

    .nickname {
      width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .school {
    margin: 10px 0;
    img {
      width: 20px;
      height: 25px;
    }
  }
  .down-like {
    display: flex;
    justify-content: space-between;
    .down,
    .like {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
}
.work-name {
  color: #e8b152;
  font-size: 26px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
